/**
 * Analysis Routes Constants
 * Falcon Analysis App
 */

export const ANALYSIS_ROUTES = {
  HOME: '/analysis',
  REPORTS: '/analysis/reports',
  INSIGHTS: '/analysis/insights',
} as const;
